<template>
  <!-- 组件 -->
  <div class="application_cases"> 
    <div class="company_title"  @click="goDases()">
      应用案例
    </div>
    <div class="company_warn">
      方案应用涵盖城管等政府部门、大型工程单位、运输车队、装修业主等
    </div>  
    <div class="application">
      <div class="city_building case">
        <div class="touch" id="box1">
          <div class="touch_box" @click="onBox(1)">
            <img class="building_img" src="/static/img/index/towerIcon.png" alt="">
            <div class="building_line"></div>
            <div class="building_title">
              城市建筑垃圾智慧监管
            </div>
          </div>
          <div class="city_title">
            城市建筑垃圾智慧监管 
          </div>
          <div class="city_underline"></div>
          <div class="city_warn">以智能设备+信息化软件，解决城市建筑垃圾装、运、存管控问题</div>
          <div class="city_goto" @click="goCasesDet(0)">查看详情 <div class="arrow">→</div></div>
        </div>
      </div>
      <div class="engineering case">
        <div class="touch" id="box2">
          <div class="touch_box" @click="onBox(2)">
            <img class="building_img" src="/static/img/index/constrIcon.png" alt="">
            <div class="building_line"></div>
            <div class="building_title">
              工程渣土全周期数字化经营
            </div>
          </div>
          <div class="city_title">
            工程渣土全周期数字化经营 
          </div>
          <div class="city_underline"></div>
          <div class="city_warn">借助大数据、物联网等技术手段，解决环境污染、渣土资源流失的问题，构建循环利用生态，实现渣土资源增值</div>
          <div class="city_goto" @click="goCasesDet(1)">查看详情 <div class="arrow">→</div></div>
        </div>
      </div>
      <div class="city case">
        <div class="touch" id="box3">
          <div class="touch_box" @click="onBox(3)">
            <img class="building_img" src="/static/img/index/tipperIcon.png" alt="">
            <div class="building_line"></div>
            <div class="building_title">
              城市建筑垃圾运输车智能监管 
            </div>
          </div>
          <div class="city_title">
            城市建筑垃圾运输车智能监管 
          </div>
          <div class="city_underline"></div>
          <div class="city_warn">通过 “SaaS软件+智能车载硬件+智能算法”，解决运输监管和企业自管问题</div>
          <div class="city_goto" @click="goCasesDet(2)">查看详情 <div class="arrow">→</div></div>
        </div>
      </div>
      <div class="renovation case">
        <div class="touch" id="box4">
          <div class="touch_box" @click="onBox(4)">
            <img class="building_img" src="/static/img/index/garIcon.png" alt="">
            <div class="building_line"></div>
            <div class="building_title">
              城市装修垃圾数字清运服务  
            </div>
          </div>
          <div class="city_title">
            城市装修垃圾数字清运服务  
          </div>
          <div class="city_underline"></div>
          <div class="city_warn">实现装修垃圾产生、运输、处置三个节点的流程链接，形成受理、核实、运输、处置、付费闭环式管理体系</div>
          <div class="city_goto" @click="goCasesDet(3)">查看详情 <div class="arrow">→</div></div>
        </div>
      </div>
    </div>      
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  Watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    goDases(e){
      this.$emit("goDases",e)
    },
    goCasesDet(e){
      this.$emit("goCasesDet",e)
    },
    onBox(id){
      for(let i = 1;i<=4;i++){
        let dom = document.getElementById('box'+i)
        dom.querySelector('.touch_box').style.display = "flex"
        dom.querySelector('.city_title').style.display = "none"
        dom.querySelector('.city_warn').style.display = "none"
        dom.querySelector('.city_goto').style.display = "none"
      }
      if(id===1){
        let dom = document.getElementById('box1')
        dom.querySelector('.touch_box').style.display = "none"
        dom.querySelector('.city_title').style.display = "flex"
        dom.querySelector('.city_warn').style.display = "-webkit-box"
        dom.querySelector('.city_goto').style.display = "flex"
      }else if(id===2){
        let dom = document.getElementById('box2')
        dom.querySelector('.touch_box').style.display = "none"
        dom.querySelector('.city_title').style.display = "flex"
        dom.querySelector('.city_warn').style.display = "-webkit-box"
        dom.querySelector('.city_goto').style.display = "flex"
      }else if(id===3){
        let dom = document.getElementById('box3')
        dom.querySelector('.touch_box').style.display = "none"
        dom.querySelector('.city_title').style.display = "flex"
        dom.querySelector('.city_warn').style.display = "-webkit-box"
        dom.querySelector('.city_goto').style.display = "flex"
      }else if(id===4){
        let dom = document.getElementById('box4')
        dom.querySelector('.touch_box').style.display = "none"
        dom.querySelector('.city_title').style.display = "flex"
        dom.querySelector('.city_warn').style.display = "-webkit-box"
        dom.querySelector('.city_goto').style.display = "flex"
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import url(../home.css);
@media screen and ( min-width: 1200px ) {
  .application_cases{
    margin-top: 40px;
    width: 1920px; 
    background: #F8F9FD;
    padding: 0 360px 40px 360px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .application{
    margin-top: 30px;
    width: 1200px;
    display: flex;
    .city_building{
      background-image: url('/static/img/index/towerCrane.png');
      background-size: cover;
    }
    .engineering{
      background-image: url('/static/img/index/construction.png');
      background-size: cover;
    }
    .city{
      background-image: url('/static/img/index/tipperCar.png');
      background-size: cover;
    }
    .renovation{
      background-image: url('/static/img/index/garbage.png');
      background-size: cover;
    }
    .case{
      width: 300px;
      height: 438px;
      .touch{
        overflow: hidden;
        width: 300px;
        height: 438px;
        .touch_box{
          height: 438px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .building_img{
            width: 68px;
          }
          .building_line{
            width: 20px;
            height: 4px;
            margin-top: 26px;
            background-color: #FFFFFF;
            border-radius: 10px;
          }
          .building_title{
            margin-top: 20px;
            font-weight: 600;
            font-size: 20px;
            letter-spacing: 0.02em;
            color: #FFFFFF;
          }
        }
        
      }
      .city_title{
        display:none
      }
      .city_underline{
        display:none
      }
      .city_warn{
        display:none
      }
      .city_goto{
        display:none
      }
    }
    .touch:hover{
      background-color: rgba(14, 160, 73, 0.7);
      .touch_box{
        display: none;
      }
      .city_title{
        font-weight: bold;
        font-size: 20px;
        letter-spacing: 0.02em;
        color: #FFFFFF;
        margin: 60px 0 0 20px;
        display: flex;
      }
      .city_underline{
        width: 80px;
        height: 5px;
        background: #FFFFFF;
        border-radius: 100px;
        margin: 18px 0 0 20px;
        display: flex;
      }
      .city_warn{
        width: 259px ;
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 400;
        line-height: 20px;
        margin: 31px 0 0 20px;
        display: flex;
      }
      .city_goto{
        width: 141px;
        height: 46px;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: 16px;
        color: #4FB054;
        margin: 150px 0 0 20px;
        cursor: pointer;
        .arrow{
          font-size: 32px;
          margin-left: 10px;
        }
      }
    }
  }
}
@media screen and ( min-width: 1000px ) and ( max-width: 1200px ) {
  .application_cases{
    margin-top: 2.5rem;
    width: 120rem; 
    background: #F8F9FD;
    padding: 0 22.5rem 2.5rem 22.5rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .application{
    margin-top: 1.875rem;
    width: 75rem;
    display: flex;
    .city_building{
      background-image: url('/static/img/index/towerCrane.png');
      background-size: cover;
    }
    .engineering{
      background-image: url('/static/img/index/construction.png');
      background-size: cover;
    }
    .city{
      background-image: url('/static/img/index/tipperCar.png');
      background-size: cover;
    }
    .renovation{
      background-image: url('/static/img/index/garbage.png');
      background-size: cover;
    }
    .case{
      width: 18.75rem;
      height: 27.375rem;
      .touch{
        overflow: hidden;
        width: 18.75rem;
        height: 27.375rem;
        .touch_box{
          height: 27.375rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .building_img{
            width: 4.25rem;
          }
          .building_line{
            width: 1.25rem;
            height: .25rem;
            margin-top: 1.625rem;
            background-color: #FFFFFF;
            border-radius: .625rem;
          }
          .building_title{
            margin-top: 1.25rem;
            font-weight: 600;
            font-size: 1.25rem;
            letter-spacing: 0.02em;
            color: #FFFFFF;
          }
        }
      }
      .city_title{
        display:none
      }
      .city_underline{
        display:none
      }
      .city_warn{
        display:none
      }
      .city_goto{
        display:none
      }
    }
    .touch:hover{
      background-color: rgba(14, 160, 73, 0.7);
      .touch_box{
        display: none;
      }
      .city_title{
        font-weight: bold;
        font-size: 1.25rem;
        letter-spacing: 0.02em;
        color: #FFFFFF;
        margin: 3.75rem 0 0 1.25rem;
        display: flex;
      }
      .city_underline{
        width: 5rem;
        height: .3125rem;
        background: #FFFFFF;
        border-radius: 6.25rem;
        margin: 1.125rem 0 0 1.25rem;
        display: flex;
      }
      .city_warn{
        width: 16.1875rem ;
        font-size: .875rem;
        color: #FFFFFF;
        font-weight: 400;
        line-height: 1.25rem;
        margin: 1.9375rem 0 0 1.25rem;
        display: flex;
      }
      .city_goto{
        width: 8.8125rem;
        height: 2.875rem;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1rem;
        color: #4FB054;
        margin: 9.375rem 0 0 1.25rem;
        cursor: pointer;
        .arrow{
          font-size: 2rem;
          margin-left: .625rem;
        }
      }
    }
  }
}
@media screen and ( max-width: 1000px ) {
  .application_cases{
    margin-top: .75rem;
    width: 23.4375rem; 
    background: #F8F9FD;
    // padding: 0 6.875rem 0 6.875rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .application{
    margin-top: .625rem;
    width: 23.4375rem;
    display: flex;
    padding: 0 1rem;
    box-sizing: border-box;
    flex-wrap: wrap;
    justify-content: space-between;
    .city_building{
      background-image: url('/static/img/index/towerCrane.png');
      background-size: cover;
    }
    .engineering{
      background-image: url('/static/img/index/construction.png');
      background-size: cover;
    }
    .city{
      background-image: url('/static/img/index/tipperCar.png');
      background-size: cover;
    }
    .renovation{
      background-image: url('/static/img/index/garbage.png');
      background-size: cover;
    }
    .case{
      width: 10.4375rem;
      height: 11.6875rem;
      margin-bottom: .75rem;
      .touch{
        overflow: hidden;
        width: 10.4375rem;
        height: 11.6875rem;
        position: relative;
        .touch_box{
          height: 11.6875rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .building_img{
            width: 1.875rem;
            margin-top: 3.9375rem;
          }
          .building_line{
            width: 1rem;
            height: .0625rem;
            margin-top: .5rem;
            background-color: #FFFFFF;
            border-radius: .0625rem;
          }
          .building_title{
            width: 8.9375rem;
            text-align: center;
            margin-top: .375rem;
            font-weight: bold;
            font-size: .875rem;
            letter-spacing: 0.02em;
            color: #FFFFFF;
          }
        }
        .city_title{
          width: 9.1875rem;
          font-weight: 600;
          font-size: .875rem;
          line-height: 1.25rem;
          letter-spacing: 0.02em;
          color: #FFFFFF;
          margin: .75rem 0 0 .75rem;
          display:none;
        }
        .city_underline{
          display:none;
        }
        .city_warn{
          position: absolute;
          top: 3.75rem;
          left: .75rem;
          width: 9.1875rem;
          font-size: .625rem;
          line-height: .875rem;
          letter-spacing: 0.02em;
          color: #FFFFFF;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          display:none;
        }
        .city_goto{
          position: absolute;
          bottom: 0;
          width: 10.4375rem;
          height: 2.4375rem;
          padding: .75rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: rgba(0, 0, 0, 0.8);
          font-weight: 400;
          font-size: .6875rem;
          line-height: .9375rem;
          letter-spacing: 0.02em;
          color: #FFFFFF;
          display:none;
          cursor: pointer;
          .arrow{
            
          }
        }
        
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/home-case.vue